import { render, staticRenderFns } from "./AccountBar.vue?vue&type=template&id=790ba583&scoped=true&"
import script from "./AccountBar.vue?vue&type=script&lang=js&"
export * from "./AccountBar.vue?vue&type=script&lang=js&"
import style0 from "./AccountBar.vue?vue&type=style&index=0&id=790ba583&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ba583",
  null
  
)

export default component.exports